import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../../utils/api';
import BackButton from '../../components/common/BackButton';

const ROLE_BADGE = {
  buyer: { bg:'var(--blue-light)', color:'var(--blue)', label:'🛒 Buyer' },
  agent: { bg:'var(--orange-light)', color:'var(--orange)', label:'🤝 Agent' },
};

export default function IncomingRequestsPage() {
  const navigate = useNavigate();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading]   = useState(true);

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/requests/incoming');
      setRequests(data.requests);
    } catch {} finally { setLoading(false); }
  };

  const accept = async (id, requester) => {
    try {
      await api.put(`/requests/${id}/accept`);
      setRequests(p => p.filter(r => r._id !== id));
      toast.success(`Request accepted! ${requester.name} has been notified.`);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error accepting request');
    }
  };

  return (
    <div className="page">
      <div className="header header--simple">
        <BackButton />
        <div>
          <div className="header__title"> Incoming Requests</div>
          {/* <div className="header__subtitle">Buyers and agents want your crops</div> */}
        </div>
        <span style={{ marginLeft:'auto', background:'rgba(255,255,255,0.2)', borderRadius:20, padding:'4px 12px', color:'white', fontSize:13 }}>{requests.length}</span>
      </div>

      <div className="container" style={{ paddingTop:'var(--sp-4)' }}>
        {loading ? (
          <div style={{ display:'flex', justifyContent:'center', padding:50 }}><div className="spinner" style={{ width:32, height:32 }} /></div>
        ) : requests.length === 0 ? (
          <div style={{ textAlign:'center', padding:50, color:'var(--gray-400)' }}>
            <div style={{ fontSize:48, marginBottom:10 }}>📥</div>
            <p style={{ fontSize:15, fontWeight:500, marginBottom:6 }}>No incoming requests yet</p>
            <p style={{ fontSize:13 }}>Mark your crops as "Ready to Sell" to get buyer requests</p>
            <button className="btn btn-primary" style={{ marginTop:14 }} onClick={() => navigate('/my-crops')}>View My Crops</button>
          </div>
        ) : (
          requests.map(req => {
            const rb = ROLE_BADGE[req.requesterId?.role] || ROLE_BADGE.buyer;
            return (
              <div key={req._id} className="card" style={{ padding:'14px 16px', marginBottom:12, borderLeft:'4px solid var(--green)' }}>
                {/* Requester info */}
                <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:10 }}>
                  {/* <div style={{ width:42, height:42, borderRadius:'50%', background:'var(--green)', color:'white', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:700, fontSize:18, flexShrink:0 }}>
                    {req.requesterId?.name?.[0] || '?'}
                  </div> */}

                  <div style={{ width:42, height:42, borderRadius:'50%', background:'#1A6B3C', color:'white', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:700, fontSize:18, flexShrink:0 }}>
  {req.requesterId?.name?.[0]?.toUpperCase() || '?'}
</div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:600, fontSize:14 }}>{req.requesterId?.name || 'Unknown'}</div>
                    <div style={{ fontSize:12, color:'var(--gray-400)' }}> {req.requesterId?.locationAddress || 'Location not set'}</div>
                  </div>
                  <span style={{ background:rb.bg, color:rb.color, borderRadius:20, padding:'3px 10px', fontSize:12, fontWeight:500 }}>{rb.label}</span>
                </div>

                {/* Request details */}
                <div style={{ background:'var(--green-light)', borderRadius:'var(--radius-sm)', padding:'10px 12px', marginBottom:10 }}>
                  <div style={{ fontSize:16, fontWeight:700, color:'var(--green)', marginBottom:4 }}>
                    {req.quantity} {req.quantityUnit} of {req.cropName}
                  </div>
                  {req.offeredPrice && (
                    <div style={{ fontSize:14, color:'var(--gray-700)' }}>
                      💰 Offering: <strong>₹{req.offeredPrice} {req.offeredPriceUnit?.replace(/_/g,' ')}</strong>
                    </div>
                  )}
                  {req.preferredLocation && (
                    <div style={{ fontSize:13, color:'var(--gray-600)', marginTop:2 }}> Near: {req.preferredLocation}</div>
                  )}
                  {req.notes && (
                    <div style={{ fontSize:13, color:'var(--gray-600)', marginTop:4, fontStyle:'italic' }}>"{req.notes}"</div>
                  )}
                </div>

                {/* Date */}
                <div style={{ fontSize:12, color:'var(--gray-400)', marginBottom:10 }}>
                  Requested {new Date(req.createdAt).toLocaleDateString('en-IN', { day:'numeric', month:'short', year:'numeric' })}
                </div>

                {/* Actions */}
                <div style={{ display:'flex', gap:8 }}>
                  {/* Call buyer/agent directly */}
                  <a href={`tel:+91${req.requesterId?.mobile}`} className="btn btn-outline" style={{ flex:1, justifyContent:'center', display:'flex' }}>
                    📞 Call {req.requesterId?.role === 'agent' ? 'Agent':'Buyer'}
                  </a>
                  {/* Accept request — notifies them */}
                  <button className="btn btn-primary" style={{ flex:1 }}
                    onClick={() => accept(req._id, req.requesterId)}>
                    ✅ Accept
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
